import { NgModule } from 'ng-metadata/core';
import {PrmPurchaseRequest} from './purchaseRequest.directive';



@NgModule({
    declarations: [
        PrmPurchaseRequest
    ],
    providers:[],
    imports:[]
})
export class PurchaseRequestModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/purchaseRequest/purchaseRequest.module.ts